import { SidebarLink, useSidebar } from '@repo/ui/aceternity/sidebar'
import { useIsMobile } from '@repo/ui/hooks/use-mobile'
import { Link, type LinkProps, useLocation } from '@tanstack/react-router'
import { ClipboardCheck, Handshake, Sheet } from 'lucide-react'
import type { ReactElement } from 'react'
import { useTranslation } from '@/lib/i18n'

function AdminNavGroups() {
	const { t } = useTranslation()
	const { setOpen } = useSidebar()
	const isMobile = useIsMobile()
	const documentDetail = useLocation({
		select: (location) => location.pathname.startsWith('/documents/')
	})

	// On mobile the menu is a full-screen sheet: leave it once a page is picked.
	const handleNavigate = () => {
		if (isMobile) {
			setOpen(false)
		}
	}

	const links: {
		icon: ReactElement
		label: string
		to: LinkProps['to']
	}[] = [
		{ icon: <Sheet />, label: t('po:page_title'), to: '/' },
		{
			icon: <ClipboardCheck />,
			label: t('po:corrections.title'),
			to: '/corrections'
		},
		{
			icon: <Handshake />,
			label: t('esclusive:page_title'),
			to: '/esclusive'
		}
	]

	return (
		<div className='flex flex-col gap-1'>
			{links.map((link) => (
				<SidebarLink
					className='data-[status=active]:bg-background data-[status=active]:font-medium data-[status=active]:text-foreground data-[status=active]:shadow-[0_0_0_1px_var(--sidebar-border),0_1px_2px_oklch(0.3_0.02_55/0.08)] data-[status=active]:[&_svg]:text-primary'
					icon={link.icon}
					key={link.label}
					label={link.label}
					render={
						<Link
							activeOptions={{
								exact: link.to === '/',
								includeSearch: false
							}}
							aria-current={
								link.to === '/' && documentDetail
									? 'page'
									: undefined
							}
							data-status={
								link.to === '/' && documentDetail
									? 'active'
									: undefined
							}
							onClick={handleNavigate}
							to={link.to}
						/>
					}
				/>
			))}
		</div>
	)
}

export { AdminNavGroups }
